// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__1iwJi","name":"ConsentHeader_name__2aGxq","birthday":"ConsentHeader_birthday__3HUhY","skeleton":"ConsentHeader_skeleton__2Y1cH"};